import React, { FC } from 'react';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';
import { EntityStatus } from '@yakoffice/publisher-types';
import { ICheckedEntity } from '../../entities/Entities';
import style from '../../../components/tables/filters/table-filters.module.sass';
import filterIcon from '../../../components/tables/filters/filter_list.svg';

interface PropsType {
    variant: string,
    statuses: string[],
    checkedEntityVersions: ICheckedEntity[]

}

export const EntityStatusToggleDropDownButton: FC<PropsType> = observer((props) => {

    const handleStatusToggle = (status: EntityStatus) => {

        runInAction(() => {
            const index = props.statuses.indexOf(status);

            if (index >= 0) {
                props.statuses.splice(index, 1);
                props.checkedEntityVersions
                    .filter(checkedEntity => checkedEntity.checked && !props.statuses.includes(checkedEntity.entityVersion.entity.status))
                    .forEach(checkedEntity => {
                        checkedEntity.checked = false;
                    });
            } else
                props.statuses.push(status);
        });
    };

    return <div className={style.tableFilters}>
        <img src={filterIcon} alt="" className={style.filterIcon} />
        {[EntityStatus.Draft, EntityStatus.Published, EntityStatus.Stopped, EntityStatus.Archived].map(status => {
            return status.length > 0 && <div key={`toggle-${status}`}
                                             className={`${style.status} ${props.statuses.includes(status) ? style.active : style.inactive}`}
                                             onClick={() => handleStatusToggle(status)}>{props.statuses.includes(status) &&
                <i className="fas fa-check" />}
                {status}</div>;
        })}
    </div>;

});
